import { useState } from 'react';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';

import { ERROR_MESSAGES } from '#client/constants/messages';

import { ContainerStyled } from './UploadDocuments.styles';
import UploadForm from './UploadForm';

import {
  ACCEPT_FILE_EXTENSIONS,
  UPLOAD_ERROR_CODES,
  UPLOAD_FILE_MAX_SIZE_IN_BYTE
} from '../constants/upload';

function UploadDocuments({
  isDragEnter,
  documentType,
  fileName,
  status,
  priorityTitle,
  handleUpload,
  handleRemoveFileSelected
}) {
  const [errorMessage, setErrorMessage] = useState('');

  const handleDrop = (acceptedFiles, fileRejections) => {
    if (fileRejections?.length > 0) {
      fileRejections.forEach((file) => {
        file.errors.forEach((err) => {
          if (err.code === UPLOAD_ERROR_CODES.FILE_TO_LARGE) {
            setErrorMessage(ERROR_MESSAGES.MAX_SIZE_UPLOAD());
          }
          if (err.code === UPLOAD_ERROR_CODES.FILE_INVALID_TYPE) {
            setErrorMessage(ERROR_MESSAGES.FILE_TYPE_UPLOAD);
          }
        });
      });
      return;
    }
    handleUpload?.(acceptedFiles[0]);
    setErrorMessage('');
  };

  const isNotEmpty = Boolean(fileName);
  const { getRootProps, getInputProps, isDragAccept, isDragReject, open } = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    multiple: false,
    disabled: isNotEmpty,
    useFsAccessApi: false,
    maxSize: UPLOAD_FILE_MAX_SIZE_IN_BYTE,
    accept: { ...ACCEPT_FILE_EXTENSIONS },
    onDrop: handleDrop
  });

  return (
    <Stack spacing="4px">
      <ContainerStyled
        {...getRootProps({ isDragAccept, isDragReject })}
        hasErrors={Boolean(errorMessage)}
        isDragEnter={isDragEnter}
      >
        <input
          {...getInputProps()}
          data-testid="dropzone"
        />
        <UploadForm
          documentType={documentType}
          fileName={fileName}
          handleClick={open}
          handleRemoveFileSelected={handleRemoveFileSelected}
          priorityTitle={priorityTitle}
          status={status}
        />
      </ContainerStyled>
      {Boolean(errorMessage) && (
        <Text
          color="red"
          size="md"
        >
          {errorMessage}
        </Text>
      )}
    </Stack>
  );
}

UploadDocuments.propTypes = {
  isDragEnter: PropTypes.bool,
  documentType: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  priorityTitle: PropTypes.string,
  handleUpload: PropTypes.func.isRequired,
  handleRemoveFileSelected: PropTypes.func.isRequired,
  fileName: PropTypes.string
};

export default UploadDocuments;
